var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.shouldShowAlert)?_c('v-alert',{staticClass:"mb-4 mt-2",attrs:{"type":_vm.alertType,"prominent":"","dense":"","outlined":"","text":""}},[_c('v-row',{attrs:{"align":"center"}},[_c('v-col',{staticClass:"grow"},[_c('strong',[_vm._v(_vm._s(_vm.alertMessage))])])],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }